import { Input, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import React from "react";

export default function LabelNumber({
  label,
  name,
  onChange,
  value,
  placeholder,
  disabled,
  defaultValue,
  hint
}) {
  return (
    <>
      <div className="inputLabel">
        {label}
        {hint && (
          <Tooltip title={hint}>
            <QuestionCircleOutlined style={{ marginLeft: 6, fontSize: 12, color: '#8c8c8c', cursor: 'help' }} />
          </Tooltip>
        )}
      </div>
      <Input
        type="number"
        disabled={disabled}
        defaultValue={defaultValue}
        name={name}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
      />

    </>
  );
}
